import React, { useState, useEffect } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "animate.css";
import { MdPersonRemoveAlt1 } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";

function GroupsStaffTableData(Props) {
  const data = Props.Staff === null ? [] : Props.Staff;
  const navigate = useNavigate();

  const DeleteStaffHandler = (value) => {
    getAuthorization()
      .post(`company/remove_group_staff/${Props.ID}/`, {
        staff_id: value.row.original.staff_id,
      })
      .then((res) => {
        Swal.fire({
          position: "top-end",
          title: "Staff Removed!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
        navigate("/dashboard/management/company-staff");
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const Permissions = useSelector((state) => state.user.userPermissions);
  const editgroup = Permissions.find(
    (o) => o.codename === "change_customgroups"
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        Cell: AvatarCell,
        imgAccessor: "profile_picture",
      },
      {
        Header: "Job Role",
        accessor: "job_role",
      },
      {
        Header: "Action",
        Cell: (value) => (
          <>
            {!editgroup === undefined ||
            editgroup?.codename === "change_customgroups" ? (
              <button type="button" onClick={() => DeleteStaffHandler(value)}>
                <MdPersonRemoveAlt1 size={30} color="#B10000" />
              </button>
            ) : (
              <button
                disabled
                type="button"
                onClick={() => DeleteStaffHandler(value)}
              >
                <MdPersonRemoveAlt1 size={30} color="#B10000" />
              </button>
            )}
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3">
          <Table columns={columns} data={data} text="Undefined" />
        </div>
      </main>
    </div>
  );
}

export default GroupsStaffTableData;
